import _ from 'lodash';

class SearchFieldsService {
    constructor() {
        this.searchFields = [];
    }

    setSearchFields(list) {
        this.searchFields = list;
    }

    get dateTypeFieldList() {
        const dateFields = _.filter(this.searchFields, (item) => _.get(item, 'type') === 'DATE');
        return _.map(dateFields, (item) => _.get(item, 'name'));
    }

    get numTypeFieldList() {
        const numFields = _.filter(this.searchFields, (item) => _.get(item, 'type') === 'NUM');
        return _.map(numFields, (item) => _.get(item, 'name'));
    }
}
const searchFieldsService = new SearchFieldsService();

export default searchFieldsService;
